module.exports = __webpack_public_path__ + "img/brake-secondary.62118d32.svg";